/**
 * 应用默认语言。
 *
 * 全局唯一来源：
 * - src/index.tsx 中 useStorage('language', DEFAULT_LANG) 的 UI 兜底
 * - src/utils/request.ts 中请求拦截器 X-Language 的兜底
 *
 * 修改此常量即可同步前后端默认语言，切勿在消费处硬编码字面量。
 */
export const DEFAULT_LANG = 'zh-CN';
const i18n = {
  'en-US': {
    'menu.system': 'System',
    'menu.workbench': 'Workbench',
    'menu.plan': 'Plan',
    'menu.purchase': 'Purchase',
    'menu.delivery': 'Delivery',
    'menu.warehouse': 'Warehouse',
    'menu.finance': 'Finance',
    'menu.product': 'Product',
    'menu.sales': 'Sales',
    'menu.produce': 'Produce',
    'menu.produce.ticket': 'Work Ticket',
    'menu.produce.ticketDetail': 'Work Ticket Detail',
    'menu.produce.ticketTransfer': 'Work Ticket Material Transfer',
    'menu.produce.ecn': 'ECN',
    'menu.produce.ecnDetail': 'ECN Detail',
    'menu.corp': 'Corporation',
    'menu.result': 'Result',
    'menu.exception': 'Exception',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.result.success': 'Success',
    'menu.system.ops': 'Ops',
    'menu.workbench.agent': 'AI Agent',
    'menu.workbench.home': 'Home',
    'menu.plan.plan': 'Plan',
    'menu.plan.planDetail': 'Plan Detail',
    'menu.plan.request': 'Request',
    'menu.plan.requestDetail': 'Request Detail',
    'menu.plan.subcontract': 'Subcontract',
    'menu.purchase.comparison': 'Comparison',
    'menu.purchase.pending': 'Pending',
    'menu.purchase.bidding': 'Bidding',
    'menu.purchase.inquiry': 'Inquiry',
    'menu.purchase.priceHistory': 'Price History',
    'menu.purchase.order': 'Order',
    'menu.purchase.orderDetail': 'Purchase Order',
    'menu.purchase.statement': 'Statement',
    'menu.delivery.follow': 'Follow',
    'menu.delivery.orderDetail': 'Purchase Order',
    'menu.delivery.delivery': 'Delivery',
    'menu.delivery.deliveryDetail': 'Delivery Detail',
    'menu.delivery.receive': 'Receipt',
    'menu.delivery.receiveHistory': 'Receipt History',
    'menu.delivery.receiveDetail': 'Delivery Order',
    'menu.delivery.return': 'Return',
    'menu.delivery.returnHistory': 'Return History',
    'menu.delivery.returnDetail': 'Return Order',
    'menu.delivery.fee': 'Fee',
    'menu.delivery.inspect': 'Inspect',
    'menu.warehouse.stock': 'Stock',
    'menu.warehouse.inbound': 'Inbound',
    'menu.warehouse.inboundHistory': 'Inbound History',
    'menu.warehouse.inboundDetail': 'Inbound Detail',
    'menu.warehouse.outbound': 'Outbound',
    'menu.warehouse.outboundHistory': 'Outbound History',
    'menu.warehouse.outboundDetail': 'Outbound Detail',
    'menu.warehouse.zone': 'Zone',
    'menu.warehouse.import': 'Import',
    'menu.warehouse.counting': 'Counting',
    'menu.warehouse.disassemblyEdit': 'Split Inbound',
    'menu.finance.setup': 'Setup',
    'menu.finance.fee': 'Fee',
    'menu.finance.payment': 'Payment',
    'menu.finance.report': 'Report',
    'menu.product.category': 'Category',
    'menu.product.material': 'Materials',
    'menu.product.materialHistory': 'Materials History',
    'menu.product.import': 'Import',
    'menu.product.substitute': 'Substitute',
    'menu.product.bom': 'BOM',
    'menu.product.bomDetail': 'BOM Detail',
    'menu.sales.order': 'Sales Order',
    'menu.sales.orderDetail': 'Sales Order Detail',
    'menu.sales.delivery': 'Delivery',
    'menu.corp.general': 'General',
    'menu.corp.organization': 'Organization',
    'menu.corp.supplier': 'Supplier',
    'menu.corp.customer': 'Customer',
    'menu.corp.address': 'Address',
    'menu.corp.contact': 'Contact',
    'menu.corp.log': 'Log',
    'menu.navbar.help': 'Help Center',
    'menu.navbar.profile': 'Profile',
    'menu.navbar.logout': 'Logout',
    'menu.navbar.logout.description': 'Are you sure want to logout?',
    'menu.navbar.logout.ok': 'OK',
    'menu.navbar.logout.cancel': 'Cancel',
    'settings.navbar.theme.toDark': 'To use dark mode',
    'settings.navbar.theme.toLight': 'To use light mode',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to '
  },
  'zh-CN': {
    'menu.system': '系统',
    'menu.workbench': '工作台',
    'menu.plan': '计划',
    'menu.purchase': '采购',
    'menu.delivery': '交付',
    'menu.warehouse': '仓库',
    'menu.finance': '财务',
    'menu.product': '产品',
    'menu.sales': '销售',
    'menu.produce': '生产',
    'menu.produce.ticket': '工单',
    'menu.produce.ticketDetail': '工单详情',
    'menu.produce.ticketTransfer': '工单间物料调拨',
    'menu.produce.ecn': '变更',
    'menu.produce.ecnDetail': '工程变更详情',
    'menu.corp': '企业',
    'menu.result': '结果页',
    'menu.exception': '异常页',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.result.success': '成功页',
    'menu.system.ops': '运维',
    'menu.workbench.agent': '智能体',
    'menu.workbench.home': '首页',
    'menu.plan.plan': '计划',
    'menu.plan.planDetail': '计划详情',
    'menu.plan.request': '需求',
    'menu.plan.requestDetail': '需求详情',
    'menu.plan.subcontract': '委外',
    'menu.purchase.comparison': '比价',
    'menu.purchase.pending': '待办',
    'menu.purchase.bidding': '竞价',
    'menu.purchase.inquiry': '询价',
    'menu.purchase.priceHistory': '价格履历',
    'menu.purchase.order': '订单',
    'menu.purchase.orderDetail': '采购订单',
    'menu.purchase.statement': '对账',
    'menu.delivery.follow': '跟单',
    'menu.delivery.orderDetail': '采购订单',
    'menu.delivery.delivery': '发货',
    'menu.delivery.deliveryDetail': '发货单详情',
    'menu.delivery.receive': '收货',
    'menu.delivery.receiveHistory': '收货记录',
    'menu.delivery.receiveDetail': '发货单详情',
    'menu.delivery.return': '退货',
    'menu.delivery.returnHistory': '退货记录',
    'menu.delivery.returnDetail': '退货单详情',
    'menu.delivery.fee': '费用',
    'menu.delivery.inspect': '质检',
    'menu.warehouse.stock': '库存',
    'menu.warehouse.inbound': '入库',
    'menu.warehouse.inboundHistory': '入库记录',
    'menu.warehouse.inboundDetail': '入库详情',
    'menu.warehouse.outbound': '出库',
    'menu.warehouse.outboundHistory': '出库记录',
    'menu.warehouse.outboundDetail': '出库详情',
    'menu.warehouse.zone': '分区',
    'menu.warehouse.import': '导入',
    'menu.warehouse.counting': '盘点',
    'menu.warehouse.disassemblyEdit': '分拆入库',
    'menu.finance.setup': '设置',
    'menu.finance.fee': '费用',
    'menu.finance.payment': '付款',
    'menu.finance.report': '报表',
    'menu.product.category': '分类',
    'menu.product.material': '物料',
    'menu.product.materialHistory': '物料履历',
    'menu.product.import': '导入',
    'menu.product.substitute': '替料',
    'menu.product.bom': '结构',
    'menu.product.bomDetail': '结构详情',
    'menu.sales.order': '订单',
    'menu.sales.orderDetail': '销售单详情',
    'menu.sales.delivery': '发货',
    'menu.corp.general': '通用',
    'menu.corp.organization': '组织',
    'menu.corp.supplier': '供方',
    'menu.corp.customer': '客户',
    'menu.corp.address': '地址',
    'menu.corp.contact': '人员',
    'menu.corp.log': '日志',
    'menu.navbar.help': '帮助中心',
    'menu.navbar.profile': '用户信息',
    'menu.navbar.logout': '退出登录',
    'menu.navbar.logout.description': '确认退出登录吗？',
    'menu.navbar.logout.ok': '确认',
    'menu.navbar.logout.cancel': '取消',
    'settings.navbar.theme.toDark': '暗黑模式',
    'settings.navbar.theme.toLight': '亮色模式',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 '
  }
};
export default i18n;